var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "lg:flex lg:flex-shrink-0 bg-white absolute font-outfit lg:relative z-20 top-0 bottom-0 scroll__container hidden-print site-sidebar",
      class: { hidden: !_vm.sidebarOpened },
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col justify-between h-full" },
        [
          _c("CloseButton", {
            staticClass:
              "text-gray-300 hover:text-white fill-current focus:outline-none",
            on: {
              click: function ($event) {
                return _vm.$emit("closeSidebar")
              },
            },
          }),
          _c("div", { staticClass: "flex flex-col w-72" }, [
            _c(
              "div",
              { staticClass: "px-3.5 pt-6" },
              [
                _c("RouterLink", { attrs: { to: "/" } }, [_c("Logo")], 1),
                _c("div", { staticClass: "sidebar-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.currentUser.role === "ADMIN"
                          ? "Admin"
                          : _vm.currentUser.role === "MANAGER"
                          ? "Manager"
                          : "My Workspace"
                      ) +
                      " "
                  ),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "flex-1 flex flex-col bg-white px-3" }, [
              _vm.currentUser
                ? _c(
                    "nav",
                    { staticClass: "flex-1 mt-6" },
                    _vm._l(_vm.menu, function (item) {
                      return _c("div", { key: item.title }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "group text-base leading-5 font-medium focus:outline-none transition ease-in-out duration-150 items-center sidebar-wrapper text-sidenav-text",
                          },
                          [
                            item.parent
                              ? [
                                  _c(
                                    "details",
                                    {
                                      staticClass: "details-area",
                                      class: item?.color,
                                      style: {
                                        borderColor: item?.borderColor,
                                      },
                                    },
                                    [
                                      _c(
                                        "summary",
                                        {
                                          staticClass:
                                            "flex justify-between w-full items-center cursor-pointer border-b border-transparent summary-area transition duration-150 ease-in-out text-base",
                                        },
                                        [
                                          _c("SidebarItem", {
                                            attrs: {
                                              title: item.title,
                                              icon: item.icon,
                                            },
                                          }),
                                          _c("ChevronIcon", {
                                            staticClass: "arrow",
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "side-menu-links-wrap" },
                                        _vm._l(
                                          item.children,
                                          function (child, i) {
                                            return _c(
                                              "div",
                                              {
                                                key: i,
                                                staticClass:
                                                  "link-parent-holder",
                                              },
                                              [
                                                _vm._t(
                                                  "childItem",
                                                  function () {
                                                    return [
                                                      !_vm.isDisabledItem(
                                                        child.title
                                                      )
                                                        ? _c(
                                                            "RouterLink",
                                                            {
                                                              staticClass:
                                                                "group flex items-center leading-5 menu-link-item focus:outline-none transition ease-in-out duration-150 text-base",
                                                              class:
                                                                item.defaultClass,
                                                              style: `background-color: ${item?.activeColor}`,
                                                              attrs: {
                                                                to: child.slug,
                                                                activeClass: `link-active text-white ${item.childColor}`,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "SidebarItem",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      child.title,
                                                                    icon: child.icon,
                                                                    innerComponent:
                                                                      child.innerComponent,
                                                                    child: "",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "group flex items-center leading-5 menu-link-item focus:outline-none transition ease-in-out duration-150 text-base disabled-link",
                                                              class:
                                                                item.defaultClass,
                                                            },
                                                            [
                                                              _c(
                                                                "SidebarItem",
                                                                {
                                                                  attrs: {
                                                                    title:
                                                                      child.title,
                                                                    icon: child.icon,
                                                                    innerComponent:
                                                                      child.innerComponent,
                                                                    child: "",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                    ]
                                                  },
                                                  { sidebarItem: child }
                                                ),
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _vm._t(
                                    "singleItem",
                                    function () {
                                      return [
                                        _c(
                                          "RouterLink",
                                          {
                                            staticClass:
                                              "group flex items-center leading-5 focus:outline-none transition ease-in-out duration-150 text-base single-link-item",
                                            class: item.styleClass,
                                            attrs: {
                                              to: item.slug,
                                              activeClass: " text-white",
                                            },
                                          },
                                          [
                                            _c("SidebarItem", {
                                              attrs: {
                                                title: item.title,
                                                icon: item.icon,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    { sidebarItem: item }
                                  ),
                                ],
                          ],
                          2
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
          _vm.company
            ? _c(
                "div",
                { staticClass: "pb-15 px-3" },
                [
                  _c("InvitationModalWithButton", {
                    attrs: {
                      currentUser: _vm.currentUser,
                      currentUserId: _vm.currentUser.id,
                      companyId: _vm.company.id,
                      companyBusinessName: _vm.company.business_name,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }